import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import '@/assets/css/onboarding.css';
import { setActiveOnboardingDriver } from '@/store/onboarding-store';
import i18n from '../i18n';
import { scrollTablesToRight, waitForAllElements, waitForElement } from './waitForDomElements';

const startApartmentsGuide = (options = {}) => {
  const {
    onFinish = () => {},
  } = options;

  const requiredSelectors = [
    '.apartments-guide-table',
    '.apartments-guide-edit-btn-first',
    '.apartments-guide-actions-activator-first',
  ];

  return waitForAllElements(requiredSelectors)
    .then((allFound) => {
      if (!allFound) {
        return false;
      }

      let isCompleted = false;

      const steps = [
        {
          element: '.apartments-guide-table',
          popover: {
            title: i18n.t('onboarding.apartments.guide.table_title'),
            description: i18n.t('onboarding.apartments.guide.table_description'),
          },
        },
      ];

      steps.push({
        element: '.apartments-guide-edit-btn-first',
        popover: {
          title: i18n.t('onboarding.apartments.guide.edit_title'),
          description: i18n.t('onboarding.apartments.guide.edit_description'),
        },
      });

      if (document.querySelector('.apartments-guide-view-btn-first')) {
        steps.push({
          element: '.apartments-guide-view-btn-first',
          popover: {
            title: i18n.t('onboarding.apartments.guide.view_title'),
            description: i18n.t('onboarding.apartments.guide.view_description'),
          },
        });
      }

      if (document.querySelector('.apartments-guide-calendar-btn')) {
        steps.push({
          element: '.apartments-guide-calendar-btn',
          popover: {
            title: i18n.t('onboarding.apartments.guide.calendar_title'),
            description: i18n.t('onboarding.apartments.guide.calendar_description'),
            onNextClick: (_el, _step, { driver: guideDriver }) => {
              window.dispatchEvent(new Event('onboarding:apartments-guide-open-contract-menu'));
              waitForElement('.apartments-guide-contract-download-btn', 1500)
                .then(() => {
                  guideDriver.moveNext();
                });
            },
          },
        });
      }

      steps.push({
        element: '.apartments-guide-actions-activator-first',
        popover: {
          title: i18n.t('onboarding.apartments.guide.actions_title'),
          description: i18n.t('onboarding.apartments.guide.actions_description'),
        },
        onHighlightStarted: () => {
          window.dispatchEvent(new Event('onboarding:apartments-guide-open-actions-menu'));
        },
      });

      if (document.querySelector('.apartments-guide-contract-btn')) {
        steps.push({
          element: '.apartments-guide-contract-download-btn',
          popover: {
            title: i18n.t('onboarding.apartments.guide.contract_title'),
            description: i18n.t('onboarding.apartments.guide.contract_description'),
          },
          onHighlightStarted: () => {
            window.dispatchEvent(new Event('onboarding:apartments-guide-open-contract-menu'));
          },
        });
      }

      const onboardingDriver = driver({
        showProgress: true,
        allowClose: false,
        showButtons: ['previous', 'next'],
        prevBtnText: i18n.t('onboarding.prev'),
        nextBtnText: i18n.t('onboarding.next'),
        doneBtnText: i18n.t('onboarding.done'),
        steps: steps.map((step, index) => {
          if (index === steps.length - 1) {
            return {
              ...step,
              popover: {
                ...step.popover,
                onNextClick: () => {
                  isCompleted = true;
                  onboardingDriver.destroy();
                },
              },
            };
          }
          return step;
        }),
        onDestroyed: () => {
          window.dispatchEvent(new Event('onboarding:apartments-guide-close-actions-menu'));
          window.dispatchEvent(new Event('onboarding:apartments-guide-close-contract-menu'));
          if (isCompleted) {
            onFinish();
          } else if (options.onDeactivated) {
            options.onDeactivated();
          }
        },
      });

      setActiveOnboardingDriver(onboardingDriver);
      scrollTablesToRight(['.apartments-guide-table']);
      onboardingDriver.drive();

      return true;
    });
};

export { startApartmentsGuide };
export default startApartmentsGuide;
